// @flow
import { useMemo } from "react";
import RelayModernPreloader from "./RelayModernPreloader";

export default function usePreloadedRelayQuery(
  enabled: boolean,
  relayConfig: { query: any, variables?: any, environment: * },
  dependencies: ?$ReadOnlyArray<mixed>,
) {
  // NOTE: it's a little weird using `useMemo` here, but we need to preload the query
  // once only, and as early as possible (useEffect is too late) to prevent the loading
  // spinner from showing up,
  useMemo(() => {
    if (enabled) {
      RelayModernPreloader.preload(relayConfig);
    }
  }, dependencies);
}
